<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Order Address"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="editForm" :rules="rules" :model="editForm" @keydown.enter.native.prevent>
                <el-col :span="24">
                    <el-form-item label="Name" size="small" prop="buyer_name">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.buyer_name"
                            placeholder="Firstname"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Street Address" size="small" prop="street1">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.street1"
                            placeholder="Street1"
                        ></el-input>
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.street2"
                            placeholder="Street2"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Country" size="small" prop="country">
                        <el-select
                            v-model="editForm.country"
                            size="mini"
                            placeholder="Please select"
                            filterable
                            clearable
                            :disabled="countryDisabled"
                        >
                            <el-option
                                v-for="item in countryList"
                                :key="item.id"
                                :label="item.name_en"
                                :value="item.name_en"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="State/Province" size="small" prop="state">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.state"
                            placeholder="State/Province"
                        ></el-input>
                        <!-- <el-select
              v-model="editForm.state"
              size="mini"
              placeholder="Please select"
              filterable
              clearable
            >
              <el-option
                v-for="item in []"
                :key="item.id"
                :label="item.code"
                :value="item.code"
              ></el-option>
                        </el-select>-->
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="City" size="small" prop="city">
                        <el-input clearable size="small" v-model="editForm.city" placeholder="City"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Zip/Postal Code" size="small" prop="postal_code">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.postal_code"
                            placeholder="Postal Code"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Phone Number" size="small" prop="Phone">
                        <el-input
                            clearable
                            size="small"
                            v-model="editForm.phone"
                            placeholder="phone"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save" :loading="loading">Save</el-button>
            <el-button size="small" @click="editVisible = false">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            editForm: {
                buyer_name: "",
                country: "",
                state: "",
                city: "",
                street1: "",
                street2: "",
                phone: "",
                buyer_email: "",
                postal_code: "",
                house_number: "",
                default: 1
            },
            rules: {
                buyer_name: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                street1: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                country: [
                    {
                        required: true,
                        trigger: "change"
                    }
                ],
                state: [
                    {
                        required: false,
                        trigger: "change"
                    }
                ],
                city: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                postal_code: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: false,
                        trigger: "blur"
                    }
                ]
            },
            loading: false,
            countryDisabled: true,
            countryList: []
        };
    },
    methods: {
        ...mapActions(["getCountrySelect"]),
        save() {
            this.$refs["editForm"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .orderUpdateAddress(
                            {
                                order_id: this.tableItem.id,
                                ...this.editForm,
                            },
                            "post"
                        )
                        .then(res => {
                            if (res) {
                                this.loading = false;
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        closeDialog() {
            this.editForm = {};
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
            this.$parent[this.funcName]();
        },
        async initialize() {
            this.getCountrySelect().then(res => {
                this.countryList = res.data;
            });
            this.getOrderDetail();
        },
        getOrderDetail() {
            cmofferApi.orders({}, "get", this.tableItem.id).then(res => {
                if (res) {
                    let { orders_address } = res.data;
                    this.editForm = orders_address;
                    this.countryDisabled = !!orders_address.country;
                    // this.editForm.country = +orders_address.country;
                }
            });
        }
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String
    },
    watch: {
        /* tableItem: {
      handler(val) {
        this.editForm = { ...val };
      },
    }, */
        editVisible() {
            if (this.editVisible) {
                this.initialize();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.edit {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
    }
}
</style>
